import type { AccountSnapshot } from "../../shared/contracts";

export function shouldAutoExpandAccount(
  snapshot: Pick<AccountSnapshot, "positions" | "pendingOrders"> | null | undefined,
  customized: boolean,
): boolean {
  return !customized && !!snapshot &&
    (snapshot.positions.length > 0 || snapshot.pendingOrders.length > 0);
}
